<template>
  <!-- 左右收缩组件 -->
  <div class="warp">
    <div class="lzRowCol" :style="{'margin-top':marginTop}">
      <div v-if="label" :style="{width:labelWidth,'text-align':align,'text-align-last': align,color:labelColor}" class="left">
        {{ label }}
      </div>
      <div class="right">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters(['size'])
  },
  name: 'lzRowCol',
  props: {
    align: {
      type: String,
      default: 'right'
    },
    label: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: String,
      default: ''
    },
		labelColor:{
			type: String,
			default: '#4f4f4f'
		},
		marginTop:{
			type: String,
			default: '10px'
		}
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.warp {
  margin-right: 5px;
}

.lzRowCol {
  display: flex;
  align-items: center;

  .left {
    font-size: 14px;
    padding: 0 5px;
		color: #4f4f4f;font-weight: bold;
		display: flex;white-space: nowrap;
  }

  .right {
    font-size: 14px;
    padding: 0 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lzRowCol/lzRowCol.vue